import { createAction } from '@reduxjs/toolkit';

import { EventWizardStep } from '../constants';
import { createEvent, updateEvent } from './thunks';
import { EventWizardInitializedPayload } from './types';

export const eventWizardActions = {
  initialized: createAction<EventWizardInitializedPayload>('[Event Wizard] initialized'),
  exited: createAction('[Event Wizard] exited'),
  publishButton: {
    clicked: createEvent,
  },
  updateButton: {
    clicked: updateEvent,
  },
  cancelButton: {
    clicked: createAction('[Event Wizard] cancel button clicked'),
  },
  progressTracker: {
    navigateToStep: createAction<EventWizardStep>('[Event Wizard Progress Tracker] navigate to step'),
    stepValidationCompleted: createAction<{ step: EventWizardStep; isValid: boolean }>(
      '[Event Wizard Progress Tracker] Step validation completed'
    ),
  },
  form: {
    validity: {
      changed: createAction<boolean>('[Event Wizard Form] validity changed'),
    },
    completed: createAction('[Event Wizard Form] completed'),
  },
  details: {
    videoDropzone: {
      fileSelected: createAction('[Event Wizard Details Video Dropzone] file selected'),
      uploadCanceled: createAction('[Event Wizard Details Video Dropzone] upload canceled'),
      uploadCompleted: createAction('[Event Wizard Details Video Dropzone] upload completed'),
      uploadFailed: createAction<string>('[Event Wizard Details Video Dropzone] upload failed'),
    },
  },
  eventLimitReachedModal: {
    confirmedButton: {
      clicked: createAction('[Event Wizard Event Limit Reached Modal] confirmed button clicked'),
    },
  },
};
